import { getApiBaseUrl } from '../config/api';

const MAX_LOGO_BYTES = 8 * 1024 * 1024;

/**
 * Read a File as a data URL for JSON upload to the API.
 */
export function fileToDataUrl(file) {
  if (!file) {
    return Promise.reject(new Error('Company logo is required to begin production.'));
  }
  if (file.size > MAX_LOGO_BYTES) {
    return Promise.reject(new Error('Company logo must be 8MB or smaller.'));
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Unable to read company logo file.'));
    reader.readAsDataURL(file);
  });
}

/**
 * Submit an inflatable enclosure purchase inquiry (no payment).
 */
export async function submitInflatableInquiry(payload) {
  const baseUrl = getApiBaseUrl();
  if (!baseUrl) {
    throw new Error('API base URL is not configured.');
  }

  const cleanBaseUrl = baseUrl.replace(/\/$/, '');
  const url = `${cleanBaseUrl}/guides/inflatable-inquiry`;

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    throw new Error(data?.error || 'Unable to submit inquiry. Please try again.');
  }

  return data;
}
